import { Table, Tag } from 'antd';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { SelectTableFilter } from 'components/Filters/SelectTableFilter';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { formatDate, isEmail } from 'utils';

const methodFilter = [
  {
    key: 'GET',
    value: 'Чтение',
  },
  {
    key: 'POST',
    value: 'Создание',
  },
  {
    key: 'PUT',
    value: 'Обновление',
  },
  {
    key: 'DELETE',
    value: 'Удаление',
  },
];

const methodFilterMap = {
  GET: 'Чтение',
  POST: 'Создание',
  PUT: 'Обновление',
  DELETE: 'Удаление',
};

const methodFilterColorMap = {
  GET: 'orange',
  POST: 'green',
  PUT: 'blue',
  DELETE: 'red',
};

function ClientsLogsTable({
  items,
  loading,
  totalRows,
  pageSize,
  current,
  filters = {},
  onChange,
  onFilter,
}) {
  const { f_date, t_date, method } = filters;

  const columns = [
    {
      title: 'Дата и время',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (date) => formatDate(date, 'DD.MM.YYYY, HH.mm'),
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[f_date, t_date]}
            onFilterChange={([start, end]) => {
              onFilter({ f_date: start, t_date: end });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_date && t_date} />,
    },
    {
      title: 'Название',
      dataIndex: 'title',
      key: 'title',
    },
    {
      width: 180,
      title: 'Тип запроса',
      dataIndex: 'method',
      key: 'method',
      render: (value) => {
        return (
          <Tag color={methodFilterColorMap[value]}>
            {methodFilterMap[value]}
          </Tag>
        );
      },
      filterDropdown: () => {
        return (
          <SelectTableFilter
            value={method}
            dataSourse={methodFilter}
            placeholder="Выберите метод"
            getSelectedItem={(method) => onFilter({ method })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={method} />,
    },
    {
      title: 'Запрос',
      dataIndex: 'path',
      key: 'path',
    },
    {
      width: 120,
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
    },
    {
      title: 'Время запроса',
      dataIndex: 'proccess_time',
      key: 'proccess_time',
    },
    {
      title: 'Выполнил действие',
      dataIndex: 'username',
      key: 'username',
      render: (data, rec) => {
        return isEmail(data) ? data : rec.full_name;
      },
    },
    {
      title: 'Клиент',
      dataIndex: 'client_id',
      key: 'client_id',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ x: 1400, y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onChange={onChange}
    />
  );
}

export { ClientsLogsTable };
